// Legal entity details for the operating company, keyed by GATSBY_SITE_COUNTRY.
//
// Single source of truth for anything that identifies the company publicly:
// footer attribution, the contact page address block, and site metadata.
// Update the address / registration numbers HERE, not inline in components.
//
// Note: this is deliberately keyed by country rather than locale. The entity
// does not change between fi-fi / sv-fi / en-fi — only between markets, where
// the Swedish site additionally operates through a registered branch (filial).

const HELSINKI_OFFICE = {
  street: `Itämerenkatu 1`,
  postalCode: `00180`,
  city: `Helsinki`,
  country: `Finland`,
}

// The parent entity behind every market.
const SOMIS = {
  legalName: `Somis Enterprises Oy`,
  businessId: `2837159-1`,
  address: HELSINKI_OFFICE,
}

const companies = {
  fi: {
    ...SOMIS,
    email: `info@someturva.fi`,
  },
  se: {
    ...SOMIS,
    email: `info@somebuddy.se`,
    // Swedish operations run through a registered branch of the Finnish parent.
    branch: {
      legalName: `SomeBuddy, filial i Sverige`,
      registrationNumber: `516412-1088`,
    },
  },
  global: {
    ...SOMIS,
    email: `info@somebuddy.com`,
  },
}

// "Itämerenkatu 1, 00180 Helsinki, Finland"
const formatAddress = ({ street, postalCode, city, country }) =>
  `${street}, ${postalCode} ${city}, ${country}`

module.exports = { companies, formatAddress }
